export const environment = {
  apiUrl: 'https://dev-api.dssaustralia.com.au/api/',
};

export const storage = {
  role: 'ROLE',
  name: 'NAME',
  refresh: 'REFRESH',
  access: 'ACCESS',
  items: 'ITEMS',
  shop_id: 'SHOP',
  tenant_id: 'TENANT',
};
